var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GridImageWithName',{attrs:{"root-class":"inspiration-list","list":_vm.filterItems,"inside-redirect":false,"inside":true}})}
var staticRenderFns = []

export { render, staticRenderFns }